import React from 'react'

const SvgCalculateOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M8.25 12.75a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1zM17.75 16.25a1 1 0 110 2h-4a1 1 0 110-2h4zM17.75 13.25a1 1 0 110 2h-4a1 1 0 110-2h4zM16.332 6.247a1 1 0 011.414 1.414l-.586.586.586.586a1 1 0 11-1.414 1.414l-.586-.586-.586.586a1 1 0 01-1.414-1.414l.586-.586-.586-.586a1 1 0 111.414-1.414l.586.586.586-.586zM10.25 7.25a1 1 0 110 2h-4a1 1 0 010-2h4z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.204 2.01A2 2 0 0122 4v16l-.01.204a2 2 0 01-1.786 1.785L20 22H4a2 2 0 01-1.99-1.796L2 20V4a2 2 0 012-2h16l.204.01zM4 20h16V4H4v16z'
    />
  </svg>
)

export default SvgCalculateOutline
